import { Action as ReduxAction, Dispatch } from 'redux';
import { CurrentTool, MultiroleLinkState } from '../../reducers/ui/ui';
import ObjectDrawingUIAction from './ObjectDrawingUIAction';
import TextboxUIAction from './TextboxUIAction';
import FreehandPenUIAction from './FreehandPenUIAction';
import ReflowableContentUIAction from './ReflowableContentUIAction';

namespace UIAction {
  export enum ActionType {
    SET_CURRENT_TOOL = 'UI_SET_CURRENT_TOOL',
    SET_MULTIROLE_LINK_STATE = 'UI_SET_MULTIROLE_LINK_STATE',
    SET_HANDERASING_WIDTH = 'UI_SET_HANDERASING_WIDTH',
    SET_MARKER_SELECTED_COLOR_INDEX = 'UI_SET_MARKER_SELECTED_COLOR_INDEX',
    SET_LEARNING_PEN_WIDTH_INDEX = 'UI_SET_LEARNING_PEN_WIDTH_INDEX',
  }

  interface SetCurrentToolAction extends ReduxAction {
    type: typeof ActionType.SET_CURRENT_TOOL;
    currentTool: CurrentTool;
  }

  interface SetMultiroleLinkStateAction extends ReduxAction {
    type: typeof ActionType.SET_MULTIROLE_LINK_STATE;
    state: MultiroleLinkState;
  }

  interface SetHanderasingWidthAction extends ReduxAction {
    width: number;
    type: typeof ActionType.SET_HANDERASING_WIDTH;
  }

  interface SetMarkerSelectedColorIndexAction extends ReduxAction {
    index: number;
    type: typeof ActionType.SET_MARKER_SELECTED_COLOR_INDEX;
  }

  interface SetLearningPenWidthIndexAction extends ReduxAction {
    widthIndex: number;
    type: typeof ActionType.SET_LEARNING_PEN_WIDTH_INDEX;
  }

  export type Action =
    SetCurrentToolAction
    | SetMultiroleLinkStateAction
    | SetHanderasingWidthAction
    | SetMarkerSelectedColorIndexAction
    | SetLearningPenWidthIndexAction
    | ObjectDrawingUIAction.Action
    | FreehandPenUIAction.Action
    | TextboxUIAction.Action
    | ReflowableContentUIAction.Action;

  export function isDomesticAction(action: ReduxAction): action is Action {
    if (ObjectDrawingUIAction.isDomesticAction(action)) {
      return true;
    }

    if (TextboxUIAction.isDomesticAction(action)) {
      return true;
    }

    if (FreehandPenUIAction.isDomesticAction(action)) {
      return true;
    }

    if (ReflowableContentUIAction.isDomesticAction(action)) {
      return true;
    }

    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }

  export function setCurrentTool(currentTool: CurrentTool, dispatch: Dispatch<ReduxAction>) {
    dispatch({ currentTool, type: ActionType.SET_CURRENT_TOOL });
  }

  export function setMultiroleLinkState(
    state: MultiroleLinkState,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ state, type: ActionType.SET_MULTIROLE_LINK_STATE });
  }

  export function setHanderasingWidth(width: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ width, type: ActionType.SET_HANDERASING_WIDTH });
  }

  export function setMarkerSelectedColorIndex(index: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ index, type: ActionType.SET_MARKER_SELECTED_COLOR_INDEX });
  }

  export function setLearningPenWidthIndex(widthIndex: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ widthIndex, type: ActionType.SET_LEARNING_PEN_WIDTH_INDEX });
  }
}

export default UIAction;
